import { React, useState } from "react";
import {
  Container,
  CardContainer,
  CMdExpandMore,
  CardTitle,
  MedicalCard,
  MedicalSearch,
  MedicalTab,
  Table,
  PurpleText,
  PricingTable,
  ImageDollor,
  ImageDollorRotate,
  PriceEndCostText,
  PricingTabSection,
  PopupHeading,
  PopupBody,
  ButtonBody,
} from "../../../style/PMCStyle/PMCPricing";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import { CustomDiv } from "../../../style/shared";
import { Button, ButtonGrey } from "../../../style/Button";
import { Checkbox, Input, Modal } from "@material-ui/core";
import TitlDollar from "../../../assets/tiltdollar.png";
import Medication from "./Medication";
import CopayMedizen from "../../../assets/pharmcy/Copay Medizen.jpg"
import CopayPrimera from "../../../assets/pharmcy/Copay Primera.png"
import PayAs from "./../../../assets/Pmc/Ads/Asset-22.png";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import { Paper, Typography } from "@material-ui/core";
import { useHistory } from "react-router-dom";


function getModalStyle() {
  const top = 50;
  const left = 45;

  return {
    right: `0%`,
    left: `0%`,
    top: `10%`,
    margin: `0 auto`,
  };
}

export function Popup({ onClose, onClick }) {
  const [dispensedPopup, setIsDispensedPopup] = useState(false)
  const handleOutsideClick = (e) => {
    if (e.target.className === "overlay") {
      onClose();
    }
  };

  return (
    <div
      className="overlay"
      onClick={handleOutsideClick}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0,0,0,0.5)",
        zIndex: "1000",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          border: "1px solid #c5c5c5",
          width: "600px",
        }}
      >
        <PopupHeading>
          <h2> CDS Hook Example</h2>
          <button onClick={onClose}>X</button>
        </PopupHeading>
        <PopupBody>
          <h5>Pharmacy Saving Program</h5>
          <p> Discounted Price of $11.06</p>
          <a href="#">Link to Medizen Affordablity Program</a>
        </PopupBody>
        <ButtonBody className="row">
          <div className="col-md-4 col-xs-12">
            <button className="printButton">Print Summary</button>
          </div>
          <div className="col-md-8 col-xs-12 text-right">
            <button
              className="button4"
              onClick={onClick}
            >
              Display Coupon
            </button>
            <button
              className="button4"
            >
              send
            </button>
          </div>
        </ButtonBody>

      </div>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: 600,
    height: 700,
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #808080",
    borderRadius: 10,
    boxShadow: theme.shadows[5],
    padding: 0,
    overflow: "auto",
  },
  heading: {
    color: "#0389fb",
    fontSize: 15,
    fontFamily: "Arial",
    display: "flex",
    paddingBottom: 10,
    paddingLeft: 10,
  },
  sample: {
    backgroundColor: "#03b3fb",
    fontSize: 10,
    fontWeight: "Bold",
    paddingTop: 0,
    margin: 10,
    height: 20,
    padding: "0px",
    width: "180px",
    color: "white",
    borderRadius: 20,
    "&:hover": {
      backgroundColor: "#0389fb",
      color: "white",
    },
  },
  column: {
    marginLeft: 25,
    borderBottom: "0.5px solid #808080",
  },
  box1: {
    display: "block",
    float: "right",
    textAlign: "center",
    marginBottom: 10,
    height: 50,
    borderRight: "none",
    border: ".5px solid #808080",
    borderRadius: 0,
    width: 145,
    boxShadow: "none",
  },
  box2: {
    display: "block",
    float: "right",
    textAlign: "center",
    marginBottom: 10,
    height: 60,
    marginTop: -5,
    border: ".5px solid #808080",
    borderRadius: 0,
    width: 155,
    backgroundColor: "#666666",
    boxShadow: "none",
  },
  box3: {
    display: "block",
    float: "right",
    marginBottom: 10,
    height: 50,
    borderLeft: "none",
    border: ".5px solid #808080",
    borderRadius: 0,
    width: 165,
    boxShadow: "none",
  },

  Button1: {
    fontWeight: "600",
    fontFamily: "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
    textAlign: "center",
    backgroundColor: "#f2f2f2",
    borderRadius: 25,
    width: 120,
    textTransform: "none",
    Display: "Block",
    float: "right",
    height: 30,
    fontSize: 10,
    marginTop: -15,
    margin: 6,
    marginRight: 10,
    "&:hover": {
      backgroundColor: "#03b3fb",
      color: "white",
    },
  },
  Button2: {
    fontWeight: "600",
    fontFamily: "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
    textAlign: "center",
    backgroundColor: "#03b3fb",
    borderRadius: 25,
    color: "White",
    width: 100,
    Display: "Block",
    float: "right",
    textTransform: "none",
    height: 30,
    fontSize: 10,
    marginTop: -15,
    marginRight: 20,
    margin: 6,
    "&:hover": {
      backgroundColor: "#0389fb",
      color: "white",
    },
  },
}));
const PmsPricing = () => {
  const history = useHistory()
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isDispensed, setIsDispensed] = useState(false);

  const [rowsState] = useState([]);
  const [open, setOpen] = useState(false);

  const [modalStyle] = useState(getModalStyle);
  const classes = useStyles();

  const dispensedPopuphandleClose = () => {
    setIsDispensed(prev => !prev)
    history.push("/Pmc/dispensed")
  };
  const dispensedPopup = (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.5)', // Optional: Adds a semi-transparent background
    }}>

      <div
        style={{
          width: "500px",
          height: "250px",
          backgroundColor: "#15BEEE",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          // border: '1px solid #000',
          boxShadow: "0px 10px 15px -3px rgba(0,0,0,0.1)",
          margin: "20px auto",
          textAlign: "center",
          position: "relative",
          borderRadius: "1rem",
          backgroundImage: "linear-gradient(315deg, #4678ED 0%, #51BEEE 74%)",

        }}
      >
        <h3 style={{ color: "white" }}>Prescription Dispensed</h3>
        <button
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            cursor: "pointer",
            fontSize: "20px",
            background: "none",
            border: "none",
          }}
          onClick={dispensedPopuphandleClose}
        >
          &times;
        </button>
      </div>
    </div>
  );

  const dispenseBtnHandler = () => {
    console.log("dispense clicked");
    setOpen(true)
  };
  const cdsHookBtnHandler = () => {
    console.log("cds Hook clicked");
    setIsPopupVisible((prevValue) => !prevValue);
  };
  const closeBtnHandler = () => {
    console.log("close btn clicked");
  };
  const closePopupHandler = () => {
    setIsPopupVisible(false);
  };
  const handleCloseParentInfo = () => {
    setIsDispensed(true)
  };
  const handleClose = () => {
    setOpen(false);
  };
  const body = (
    <div style={modalStyle} className={`${classes.paper} pricingModal`}>
      <Grid container spacing={0}>
        <Grid
          item
          xs={12}
          style={{
            borderBottom: ".5px solid #d8d6d6",
            paddingTop: 20,
            paddingLeft: 36,
          }}
        >
          <Typography
            style={{
              color: "#4678ED",
              fontWeight: 600,
              marginTop: "0px",
              fontSize: "19px",
              marginBottom: "12px",
            }}
          >
            Prescription Confirmation{" "}
            <span
              style={{
                fontWeight: "bolder",
                color: "black",
                float: "right",
                paddingRight: "30px",
              }}
            ></span>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          container
          spacing={0}
          style={{
            borderBottom: ".5px solid #808080",
            margin: 25,
            marginTop: 0,
            marginBottom: 15,
          }}
        >
          <Typography
            style={{
              padding: 10,
              fontSize: 19.5,
              fontWeight: 600,
              color: "#58595B",
              width: "100%",
            }}
          >
            Medication samples and coupons delivered right to your office.{" "}
            <span style={{ color: "#0389fb" }}>Free. Easy. Fast.</span>
          </Typography>

          <Typography
            style={{
              fontSize: 12.11,
              fontWeight: 2,
              paddingLeft: 10,
              marginTop: -10,
              width: "100%",
            }}
          >
            Request multiple products from a variety of suppliers, prescription
            saving cards, and get access to vouchers.
            <br /> Want to see the samples available to you? Find out now!
          </Typography>
          <Button
            className={classes.sample}
            style={{
              backgroundColor: "#15BEEE",
              color: "#fff",
              fontSize: "12.11px",
              padding: "4px 17px",
              width: "auto",
              height: "auto",
              fontWeight: "400",
            }}
          >
            Learn more at sample center
          </Button>
        </Grid>
        <Grid
          container
          spacing={0}
          style={{
            borderBottom: ".5px solid #808080",
            margin: 25,
            marginTop: -10,
            marginBottom: 15,
          }}
        >
          <Grid item xs={4}>
            <Typography
              style={{
                padding: 10,
                fontSize: 15.52,
                fontWeight: "600",
                paddingTopt: 20,
                color: "#606060",
              }}
            >
              Pick Up Location
              <br />
              <span style={{ fontWeight: 10, marginTop: 5 }}>
                Phone: 703-205-7034
                <br />
                Fax: 703-205-7035
              </span>
            </Typography>
          </Grid>
          <Grid item xs={7}>
            <Typography
              style={{
                padding: 10,
                fontSize: 15.52,
                fontWeight: "600",
                paddingTopt: 20,
                color: "#606060",
              }}
            >
              VA Pharmacy 10.6MU
              <br />
              <span style={{ fontWeight: 10, marginTop: 5 }}>
                7723 Jefferson Davis Highway
                <br />
                Arlington, VA 22201
              </span>
            </Typography>
          </Grid>
        </Grid>
        <PricingTable
          style={{
            fontSize: "15.52px",
            margin: "0 30px 30px",
            borderBottom: "0.5px solid rgb(128, 128, 128)",
          }}
        >
          <thead>
            <tr>
              <th>Prescriptions Sent</th>
              <th>Status</th>
              <th>
                <Checkbox />
                Coupon
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="purpleText" style={{ fontWeight: "400" }}>
                Medizen 10 MG Oral Tablet
              </td>
              <td className="pendingText" style={{ fontWeight: "400" }}>
                Pending
              </td>
              <td className="greenText" style={{ fontWeight: "400" }}>
                <ImageDollor src={TitlDollar} alt="Dollor" /> Coupon/Guide
                Available
              </td>
            </tr>
            <tr>
              <td colSpan={3} className="pendingText " style={{ fontWeight: "400", textAlign: "right" }} >
                <img src={PayAs} className="imgPopupTable" />
              </td>

            </tr>
            <tr>
              <br />
            </tr>
          </tbody>
        </PricingTable>
        {rowsState.map((name) => name)}
        <Grid item xs={12} className="pricingButtons">
          <Button
            className={classes.Button2}
            style={{
              background: "#CCCCCC",
              color: "#58595B",
              fontSize: "14px",
              fontWeight: "600",
              marginTop: "0px",
              width: "auto",
              padding: "8px 27px",
              height: "auto",
            }}
            onClick={handleCloseParentInfo}
          >
            Dispense
          </Button>
          <Button
            className={classes.Button1}
            style={{
              background: "#CCCCCC",
              color: "#58595B",
              fontSize: "14px",
              fontWeight: "600",
              marginTop: "0px",
              width: "auto",
              padding: "8px 27px",
              height: "auto",
            }}
          >
            Print Summary
          </Button>
        </Grid>
      </Grid>
      {isDispensed && dispensedPopup}
    </div>
  );

  return (
    <>
      <PricingTabSection>
        <MedicalSearch className="row">
          <div className="col-md-4 col-lg-2  col-xs-12">
            <PurpleText>Real Time Benefits Check</PurpleText>
          </div>
          <div className="col-md-5 col-lg-8 col-xs-12">
            <FormControl
              variant="outlined"
              style={{
                minWidth: "100%",
              }}
            >
              <Input
                className="select1"
                // onChange={this.handleChange}
                style={{
                  fontSize: "13.77px",
                  fontWeight: 400,
                  color: "grey",
                  paddingBottom: "7px",
                  border: "1px solid #c5c5c5",
                  padding: "6px 10px",
                  borderRadius: "4px",
                }}
                placeholder="Checking for Patient Insurance Coverage"
              />
            </FormControl>
          </div>
          <div className="col-md-3 col-lg-2 col-xs-12">
            <CustomDiv marginT="3px">
              <Button
                height="fit-content"
                backgroundColor="grey"
                marginL="15px"
                style={{
                  padding: "7px 43px",
                  height: "fit-content",
                  borderRadius: "20px",
                  fontSize: "14px",
                  backgroundImage: "none",
                  backgroundColor: "#D0D2D3",
                  color: "#606060",
                  fontWeight: 600,
                  fontFamily:
                    "'Montserrat SemiBold', 'Open Sans', Helvetica, Arial, sans-serif",
                }}
              >
                Search
              </Button>
            </CustomDiv>
          </div>
        </MedicalSearch>
        <MedicalSearch className="row">
          <div className="col-md-12 col-lg-2 col-xs-12">
            <PurpleText>
              Co - Pay <ImageDollorRotate src={TitlDollar} alt="Dollor" />
            </PurpleText>
          </div>
          <div className="col-md-12 col-lg-8 col-xs-12">
            <PricingTable>
              <thead>
                <tr>
                  <th>Prescriptions Sent</th>
                  <th>Status</th>
                  <th>
                    <Checkbox />
                    Coupon
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="purpleText">Medizen 10 MG Oral Tablet</td>
                  <td className="pendingText">Pending</td>
                  <td className="greenText">
                    <ImageDollor src={TitlDollar} alt="Dollor" /> Coupon/Guide
                    Available
                  </td>
                </tr>
              </tbody>
            </PricingTable>
            <div className="responsiveImage">
              <img src={PayAs} />
            </div>
          </div>
          <div className="col-md-12 col-lg-2 col-xs-12"></div>
        </MedicalSearch>
        <MedicalSearch className="row">
          <div className="col-md-12 col-lg-2 col-xs-12">
            <PurpleText>Price End Cost</PurpleText>
          </div>
          <div className="col-md-8 col-xs-12">
            <PriceEndCostText>$11.06</PriceEndCostText>
          </div>
          <div className="col-md-12 col-lg-2 col-xs-12"></div>
        </MedicalSearch>
      </PricingTabSection>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
          marginBottom: "50px"
        }}
        className="pricingButtons"
      >
        <Medication />
        <Button
          className="button4"
          height="fit-content"
          borderRadius="20px"
          onClick={cdsHookBtnHandler}
          style={{
            padding:"6px 37px",
            marginTop: 0,
            fontSize: "18px",
            marginLeft: "18px",
            backgroundImage: "none",
            backgroundColor: "#D0D2D3",
            color: "#606060",
            fontWeight: 600,
            fontFamily: "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
            textAlign: "center",
            float: "right",
          }}
        >
          CDS Hook
        </Button>
        <Button
          className="button4"
          height="fit-content"
          borderRadius="20px"
          style={{
            padding:"6px 37px",
            marginTop: 0,
            fontSize: "18px",
            marginLeft: "18px",
            backgroundImage: "none",
            backgroundColor: "#D0D2D3",
            color: "#606060",
            fontWeight: 600,
            fontFamily: "Montserrat, 'Open Sans', Helvetica, Arial, sans-serif",
            textAlign: "center",
            float: "right",
          }}
          onClick={closeBtnHandler}
        >
          Close
        </Button>
      </div>
      {isPopupVisible && <Popup onClose={closePopupHandler} onClick={dispenseBtnHandler} />}
      {open && <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {body}
      </Modal>}
    </>
  );
};

export default PmsPricing;
